import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import CTAButton from './CTAButton';
import CloseButton from './CloseButton';
import CancelButton from './CancelButton';
import DangerButton from './DangerButton';
import WidgetCancelButton from './WidgetCancelButton';
import OutlinedButton from './OutlinedButton';
import AnemicButton from './AnemicButton';
import IconButton from './IconButton';
import RoundButton from './RoundButton';
import DashedButton from './DashedButton';
import SelectionButton from './SelectionButton';
import ButtonGroup from './ButtonGroup';
import TextButton from './TextButton.vue';

export default {
	PrimaryButton,
	SecondaryButton,
	CTAButton,
	CloseButton,
	CancelButton,
	DangerButton,
	WidgetCancelButton,
	OutlinedButton,
	AnemicButton,
	IconButton,
	RoundButton,
	DashedButton,
	SelectionButton,
	ButtonGroup,
	TextButton,
};
